<template>
  <div class="theme-dialog modal micromodal-slide" id="modal-share" @click.stop>
    <div class="modal__overlay" :class="{ 'align-bottom': alignBottom }" tabindex="-1" data-micromodal-close>
      <div ref="modalRef" class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
        <header class="modal__header">
          <slot name="header"></slot>
          <button
            v-if="showClose"
            type="button"
            class="modal__close"
            aria-label="Close modal"
            data-micromodal-close=""
            @click="$emit('close')"
          ></button>
        </header>
        <main class="modal__content">
          <slot></slot>
        </main>
        <footer class="modal__footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

const modalRef = ref()
const emit = defineEmits(['close'])

const props = defineProps({
  showClose: {
    type: Boolean,
    default: false,
  },
  clickOutside: {
    type: Boolean,
    default: false,
  },
  alignBottom: {
    type: Boolean,
    default: false,
  },
})

onClickOutside(modalRef, () => {
  if (props.clickOutside) {
    emit('close')
  }
})
</script>

<style lang="scss" scoped>
.theme-dialog {
  @include micromodal;
  .modal__content {
    margin-top: unset;
    margin-bottom: unset;
  }

  @include mobile {
    .align-bottom {
      align-items: flex-end;
      animation: slideIn 0.2s ease-out;

      .modal__container {
        padding: $spacing-6;
        width: 100vw;
        max-width: 100vw;
        max-height: 75vh;
        border-radius: $spacing-4 $spacing-4 0 0;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.theme-dialog .modal__container {
  min-width: unset;
  width: calc(100% - #{$spacing-12});
  display: grid;
  row-gap: $spacing-6;

  @media (min-width: $breakpoint-m) {
    min-width: $breakpoint-sm;
    width: auto;
  }
}

.modal__close {
  color: $grey-300;
}

@keyframes slideIn {
  from {
    opacity: 0.9;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
